
define( 'Digi.ContactManagement.ContactManagement',
[],
function (
) {
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {

			var myAccountMenu;
			var userProfile;

			myAccountMenu = container.getComponent('MyAccountMenu');
			userProfile = container.getComponent('UserProfile');

			if (userProfile) {

				userProfile.getUserProfile().done(function (profile) {

					if(myAccountMenu && profile.type === 'COMPANY') {
						/*myAccountMenu.addGroupEntry({
							id: 'contactmanagement',
							groupid: 'registrations',
							name: 'Manage Contacts',
							index: 1,
							url: 'contact-management'
						});*/

						myAccountMenu.addGroup({
							id: 'contactmanagement',
							name: 'Manage Contacts',
							index: 5,
							url: 'contact-management'
						});

					}
				});
			}
		}
	};
});
